// Referral rewards (shared by the browser and /api/referral).
// Tuning: 50 coins per counted referral. A single premium chat theme costs CHAT_THEME_PRICE_COINS (1500) and the
// all-themes bundle CHAT_THEME_BUNDLE_COINS (5000) - see lib/premium-plans.ts - so ~40 referrals buy one theme
// and ~100 buy the bundle. Lifetime cap: REFERRAL_MAX_REWARDED x 50 coins.
export const REFERRAL_REWARD_COINS = 50
/** Coins the NEW user gets the moment a valid referral code is applied (0 = no bonus for the invited person). */
export const REFERRAL_REFEREE_BONUS_COINS = 50
/** A referred account counts after this delay. 0 = instantly (the age check + device/IP anti-abuse already ran at claim time). */
export const REFERRAL_MATURITY_MS = 0
/** Lifetime cap of rewarded referrals per account. */
export const REFERRAL_MAX_REWARDED = 100
/** Max rewards credited per UTC day (slows farming). */
export const REFERRAL_DAILY_CAP = 10
/** Max referred accounts waiting for maturity at once. */
export const REFERRAL_MAX_PENDING = 50
/** Referred sign-ups counted from one network (IP) in total - shared Wi-Fi/mobile NAT is normal, farms are not. */
export const REFERRAL_MAX_PER_IP = 3
/** Referral code can only be attached within this time after the referred account was created. */
export const REFERRAL_CLAIM_WINDOW_MS = 7 * 24 * 60 * 60 * 1000
/** An invite-link visit (browser) is remembered by network for this long so the app can auto-fill the code after a Play Store install. */
export const REFERRAL_HINT_TTL_MS = 48 * 60 * 60 * 1000

export const REFERRAL_CODE_RE = /^[A-Z2-9]{8}$/
export const normalizeReferralCode = (v: unknown): string => {
  const c = String(v ?? '').trim().toUpperCase().replace(/[^A-Z0-9]/g, '')
  return REFERRAL_CODE_RE.test(c) ? c : ''
}
export const REFERRAL_LINK_BASE = 'https://animorasocial.app/'
export const referralLink = (code: string) => `${REFERRAL_LINK_BASE}?ref=${code}`
